import {Box, Grid} from '@mui/material';
import React from 'react';
import {AutoField} from '../AutoForm/AutoFieldNew';
import {
  accountTypeField,
  adviserField,
  emailField,
  incomeField,
  inHousePlansField,
  liabilitiesField,
  nameField,
  netAssetsField,
  otherPlansField,
  ownerField,
  plansField,
  primaryPhoneField,
  propertyAssetsField,
  propositionTypeField,
  totalAssetsField,
  accountFormValues,
  businessUnitField,
  partnershipTypeField,
  leiTypeField,
  hmrcTypeField,
} from '../AccountOverview/form';
import withAutoFormNew from '../AutoForm/AutoFormNew';
import {useAccountContext} from '../../contexts/AccountContext';
import {BusinessUnitEnum} from '../../schema-types/globalTypes';
import {useAutoForm} from '../AutoForm/useAutoForm';
import {ongoingFeeField} from '../../features/recommendations/CreateRecommend/FeeField';

export const AccountForm: React.FC<{loadingFullDetails: boolean}> = ({
  loadingFullDetails,
}) => {
  const {values} = useAutoForm<accountFormValues>();
  const {accountType, account} = useAccountContext();
  return (
    <form style={{height: '100%'}}>
      <Grid container direction="row" sx={{height: '100%'}}>
        <Grid item xs={6}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            sx={{
              '& .MuiFormControl-root': {
                mb: 1,
              },
              '& input': {
                cursor: 'default',
              },
              mr: 1,
            }}
          >
            <AutoField field={nameField} readOnly />
            <AutoField field={primaryPhoneField} readOnly />
            <AutoField field={emailField} readOnly />
            <AutoField loading={loadingFullDetails} field={adviserField} readOnly />
            <AutoField loading={loadingFullDetails} field={ownerField} readOnly />
            <AutoField loading={loadingFullDetails} field={accountTypeField} readOnly />
            <AutoField
              loading={loadingFullDetails}
              field={propositionTypeField}
              readOnly
            />
            <AutoField
              loading={loadingFullDetails}
              field={partnershipTypeField}
              readOnly
            />
            <AutoField loading={loadingFullDetails} field={businessUnitField} readOnly />
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            sx={{
              '& .MuiFormControl-root': {
                mb: 1,
              },
              '& input': {
                cursor: 'default',
              },
              ml: 1,
            }}
          >
            <AutoField loading={loadingFullDetails} field={incomeField} readOnly />
            <AutoField
              loading={loadingFullDetails}
              field={propertyAssetsField}
              readOnly
            />
            <AutoField loading={loadingFullDetails} field={totalAssetsField} readOnly />
            <AutoField loading={loadingFullDetails} field={inHousePlansField} readOnly />
            <AutoField loading={loadingFullDetails} field={otherPlansField} readOnly />
            <AutoField loading={loadingFullDetails} field={plansField} readOnly />
            <>
              <AutoField loading={loadingFullDetails} field={liabilitiesField} readOnly />
              <AutoField loading={loadingFullDetails} field={netAssetsField} readOnly />
            </>
            {accountType !== BusinessUnitEnum.DA && values.ongoingFee !== null ? (
              <AutoField loading={loadingFullDetails} field={ongoingFeeField} readOnly />
            ) : null}
            {account?.isTrust && (
              <>
                <AutoField loading={loadingFullDetails} field={leiTypeField} />
                <AutoField loading={loadingFullDetails} field={hmrcTypeField} />
              </>
            )}
          </Box>
        </Grid>
      </Grid>
    </form>
  );
};

export default withAutoFormNew(AccountForm, undefined, {debugPosition: 'right'});
